// components/CountrySelect.jsx
import React from "react";

const CountrySelect = React.forwardRef(
  ({ onChange, onBlur, name, error }, ref) => {
    const countries = [
      { name: "United States", code: "US" },
      { name: "United Kingdom", code: "GB" },
      { name: "Canada", code: "CA" },
      { name: "Australia", code: "AU" },
      { name: "Germany", code: "DE" },
      { name: "France", code: "FR" },
      { name: "Italy", code: "IT" },
      { name: "Spain", code: "ES" },
      { name: "Japan", code: "JP" },
      { name: "China", code: "CN" },
      { name: "India", code: "IN" },
      { name: "Brazil", code: "BR" },
      { name: "Mexico", code: "MX" },
      { name: "South Africa", code: "ZA" },
      { name: "Nigeria", code: "NG" },
      { name: "Kenya", code: "KE" },
      { name: "Egypt", code: "EG" },
      { name: "Saudi Arabia", code: "SA" },
      { name: "United Arab Emirates", code: "AE" },
      { name: "South Korea", code: "KR" },
      { name: "Singapore", code: "SG" },
      { name: "Netherlands", code: "NL" },
      { name: "Sweden", code: "SE" },
      { name: "Norway", code: "NO" },
      { name: "Denmark", code: "DK" },
      { name: "Finland", code: "FI" },
      { name: "Switzerland", code: "CH" },
      { name: "Austria", code: "AT" },
      { name: "Belgium", code: "BE" },
      { name: "Portugal", code: "PT" },
      { name: "Greece", code: "GR" },
      { name: "Turkey", code: "TR" },
      { name: "Russia", code: "RU" },
      { name: "Ukraine", code: "UA" },
      { name: "Poland", code: "PL" },
      { name: "Czech Republic", code: "CZ" },
      { name: "Hungary", code: "HU" },
      { name: "Romania", code: "RO" },
      { name: "Bulgaria", code: "BG" },
      { name: "Argentina", code: "AR" },
      { name: "Chile", code: "CL" },
      { name: "Colombia", code: "CO" },
      { name: "Peru", code: "PE" },
      { name: "Venezuela", code: "VE" },
      { name: "Malaysia", code: "MY" },
      { name: "Indonesia", code: "ID" },
      { name: "Thailand", code: "TH" },
      { name: "Vietnam", code: "VN" },
      { name: "Philippines", code: "PH" },
      { name: "Pakistan", code: "PK" },
      { name: "Bangladesh", code: "BD" },
      { name: "Sri Lanka", code: "LK" },
      { name: "New Zealand", code: "NZ" },
      { name: "Ireland", code: "IE" },
      { name: "Israel", code: "IL" },
      { name: "Lebanon", code: "LB" },
      { name: "Jordan", code: "JO" },
      { name: "Qatar", code: "QA" },
      { name: "Kuwait", code: "KW" },
      { name: "Oman", code: "OM" },
      { name: "Bahrain", code: "BH" },
    ];

    return (
      <div>
        <label
          htmlFor={name}
          className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
        >
          Country
        </label>
        <select
          name={name}
          id={name}
          ref={ref}
          onChange={onChange}
          onBlur={onBlur}
          className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        >
          <option value="">Select a country</option>
          {countries.map((country) => (
            <option key={country.code} value={country.code}>
              {country.name}
            </option>
          ))}
        </select>
        {error && <p className="text-red-500 text-sm mt-1">{error.message}</p>}
      </div>
    );
  }
);

CountrySelect.displayName = "CountrySelect";

export default CountrySelect;
